import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const shopCardPlaceholderDefaultVariants = {}
const shopCardPlaceholderCompoundVariants = []

const shopCardPlaceholderSlotNames = [
  [
    "root",
    "shop-card-placeholder__root"
  ],
  [
    "icon",
    "shop-card-placeholder__icon"
  ]
]
const shopCardPlaceholderSlotFns = /* @__PURE__ */ shopCardPlaceholderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, shopCardPlaceholderDefaultVariants, getSlotCompoundVariant(shopCardPlaceholderCompoundVariants, slotName))])

const shopCardPlaceholderFn = memo((props = {}) => {
  return Object.fromEntries(shopCardPlaceholderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const shopCardPlaceholderVariantKeys = []
const getVariantProps = (variants) => ({ ...shopCardPlaceholderDefaultVariants, ...compact(variants) })

export const shopCardPlaceholder = /* @__PURE__ */ Object.assign(shopCardPlaceholderFn, {
  __recipe__: false,
  __name__: 'shopCardPlaceholder',
  raw: (props) => props,
  variantKeys: shopCardPlaceholderVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, shopCardPlaceholderVariantKeys)
  },
  getVariantProps
})